import { render, staticRenderFns } from "./PaymentMethodAdd.vue?vue&type=template&id=d8fad8d6&"
import script from "./PaymentMethodAdd.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports